
export const defaultTitleClasses = (titleColor) => {
  return {
    "text-textPrimary": titleColor === "textPrimary",
    "text-textSecondary": titleColor === "textSecondary",
    "text-textBlack": titleColor === "textBlack",
    "text-textLight": titleColor === "textLight",
    "text-textWhite": titleColor === "textWhite",
    "text-textGrey": titleColor === "textGrey",
    "text-textOrange": titleColor === "textOrange",
  };
};
